<template>
  <div class="wrapper">
    <div class="section">
      <div class="about-description text-center">
        <div class="features-3">
          <div class="container">
            <div class="row">
              <div class="col-md-8 mr-auto ml-auto">
                <h2 class="title">404</h2>
                <h4
                  class="description"
                >Page Not Found</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PageNotFound"
};
</script>
